
import FormatterService from '@/service/FormatterService';

export default {
    name: 'SnippetCard',

    props: {
        snippetId: {
            type: Number,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
        created: {
            type: String,
            default: '',
        },
    },

    emits: ['click-edit-snippet', 'click-delete-snippet'],

    computed: {
        optionsIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/options-dark.svg') :
                require('@/assets/icons/options-light.svg');
        },
        deleteIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/delete-dark.svg') :
                require('@/assets/icons/delete-light.svg');
        },
        penIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/pen-dark.svg') :
                require('@/assets/icons/pen-light.svg');
        },
    },

    created() {
        this.format = new FormatterService();
    },

    methods: {
        handleClickEdit() {
            this.$emit('click-edit-snippet', { id: this.snippetId, title: this.title});
        },
        handleClickDelete() {
            this.$emit('click-delete-snippet', { id: this.snippetId, title: this.title});
        },
    }

}
